export enum MobileAccountStatuses {
    UnKnown = 0
    , Yes = 1
    , No = 2
}